// SiteUp: sintaxe leve do manual da tela. O JSON de locale continua string;
// o componente enriquece na hora de pintar. Nada de v-html.

const TOKEN_RE = /\[\[(kbd|n|ui|spot):([^\]]*)\]\]/g;
const SPOT_ID_RE = /^[A-Za-z][A-Za-z0-9_-]*$/;
const TAG_RE = /<[^>]*>/g;

export const STAGGER_STEP_MS = 24;
export const STAGGER_CAP_MS = 400;

const stripTags = value => String(value).replace(TAG_RE, '');

const pushText = (nodes, value) => {
  if (!value) return;
  const last = nodes[nodes.length - 1];
  if (last?.type === 'text') {
    last.value += value;
    return;
  }
  nodes.push({ type: 'text', value });
};

export const spotSelector = id =>
  id && SPOT_ID_RE.test(id) ? `[data-testid="${id}"]` : '';

export const staggerDelayMs = (index, reduceMotion) => {
  if (reduceMotion) return 0;
  const n = Number(index);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.min(n * STAGGER_STEP_MS, STAGGER_CAP_MS);
};

export function parseManualMarkup(input) {
  const source = input == null ? '' : String(input);
  const nodes = [];
  let spot = null;
  TOKEN_RE.lastIndex = 0;
  let last = 0;
  let match = TOKEN_RE.exec(source);
  while (match) {
    if (match.index > last) {
      pushText(nodes, source.slice(last, match.index));
    }
    const kind = match[1];
    const value = stripTags(match[2]).trim();
    if (!value) {
      pushText(nodes, match[0]);
    } else if (kind === 'spot') {
      if (!spot && SPOT_ID_RE.test(value)) spot = value;
    } else {
      nodes.push({ type: kind, value });
    }
    last = TOKEN_RE.lastIndex;
    match = TOKEN_RE.exec(source);
  }
  if (last < source.length) pushText(nodes, source.slice(last));
  if (!nodes.length && source) pushText(nodes, source);
  return { nodes, spot };
}

export function collectManualSpots(block) {
  const spots = [];
  const sections = Array.isArray(block?.SECTIONS) ? block.SECTIONS : [];
  sections.forEach(section => {
    (section?.ITEMS || []).forEach(item => {
      const { spot } = parseManualMarkup(item);
      if (spot) spots.push(spot);
    });
  });
  return spots;
}
